import BPInput from 'components/BionicUI/input/BPInput';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import BPToast from 'components/BionicUI/toast/BPToast';
import { useAuth } from 'context/auth.context';
import { OnboardingPhases } from 'core/models/users/user.model';
import { FirebaseError } from 'firebase/app';
import { useNavigate } from 'react-router-dom';
import useLoginStore from 'stores/loginStore';
import useNotifyStore from 'stores/notifyStore';
import useOnboardingStore from 'stores/onboardingStore';
import { MAP_ONBOARDING_PHASE_TO_ROUTE } from 'utils';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { OnboardingEye } from '../../onboarding/Eye';
import InputBar from '../../onboarding/InputBar';
import { SequenceItem } from '../../onboarding/kyc/OnboardingKYCSequence';

const Password = () => {
  const { setPassword, user } = useLoginStore();
  const { signInWithEmail, handleProfileCreationOrLoad } = useAuth();
  const { setCurrentToast } = useNotifyStore();
  const navigate = useNavigate();
  const { setProgressStep } = useOnboardingStore();

  async function handleSubmit() {
    try {
      await signInWithEmail(user.email!, user.password!);

      const response = await handleProfileCreationOrLoad();

      if (!!response) {
        if (response.onboardingPhase === OnboardingPhases.SIGNUP) {
          setProgressStep(5);
        }
        navigate(MAP_ONBOARDING_PHASE_TO_ROUTE[response.onboardingPhase]);
      }
    } catch (error) {
      const errMsg =
        (error as FirebaseError).message ||
        'You have entered an invalid username or password';

      setCurrentToast(<BPToast message={errMsg} variant="error" />);
    }
  }

  return (
    <SequenceItem>
      <div className="inline-grid w-full max-w-[800px] px-6 grid-cols-[auto_1fr] gap-[20px] mx-auto pt-[15vh] items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Now enter your password...',
            sound: 'kyc/please-enter-your-password_1.mp3',
          }}
          showContentImmediately
        />
      </div>
      <InputBar
        showBackButton
        onClickBackButton={() => window.location.reload()}
      >
        <BPInput
          state="default"
          type="password"
          placeholder="Enter your password"
          button={{
            state: 'primary',
            onClick: handleSubmit,
            title: 'Submit',
          }}
          validate={(password) => {
            setPassword(password);
            return true;
          }}
        />
        <BPLinkButton>Forgot Password?</BPLinkButton>
      </InputBar>
    </SequenceItem>
  );
};

export default Password;
